const embeddingsManagedByShopify = [
    'Meta Pixel',
    'Shopify Analytics'
]

var intervals = {};
var shopifyFeaturesLoaded = false;

function embeddingIsAccepted(embeddingName) {
    return CCM.acceptedEmbeddings.reduce(function (accumulator, embedding) {
        return accumulator || embedding.name === embeddingName;
    }, false);
}

function getCookieKeys() {
    return document.cookie
        .split("; ")
        .filter(Boolean)
        .map(c => c.split("=")[0]);
}

function deleteCookieEverywhere(name) {
    const domains = [
        undefined,
        window.location.hostname,
        "." + window.location.hostname
    ];

    domains.forEach(domain => {
        document.cookie =
            `${name}=; Max-Age=0; path=/` +
            (domain ? `; domain=${domain}` : "");
    });
}

var firstTime = !CCM.ucid

function updateShopifyCustomerPrivacy() {

    if (typeof window.Shopify == 'object'
        && typeof window.Shopify.loadFeatures == 'function'
        && !shopifyFeaturesLoaded
    ) {
        window.Shopify.loadFeatures([{
                name: 'consent-tracking-api',
                version: '0.1',
            }],
            function (error) {
                if (error) {
                    throw error;
                }
            });

        shopifyFeaturesLoaded = true;
    }

    if (typeof window.Shopify == 'object'
        && typeof window.Shopify.customerPrivacy == 'object'
        && typeof window.Shopify.customerPrivacy.setTrackingConsent == 'function'
    ) {
        accepted = embeddingsManagedByShopify.reduce(function (accumulator, embeddingName) {
            return embeddingIsAccepted(embeddingName) && accumulator
        }, true);


        window.Shopify.customerPrivacy.setTrackingConsent({
            preferences: accepted,
            analytics: accepted,
            marketing: accepted
        }, function () {
            if (firstTime) {
                firstTime = false
            } else {
                const cookieKeys = getCookieKeys()
                cookieKeys.forEach(it => {
                    if (CCM.acceptedCookies.includes(it)) {
                        return;
                    }
                    deleteCookieEverywhere(it)
                })

                window.location.reload();
            }
        });

        window.clearInterval(intervals.shopifyCustomerPrivacy);
        intervals.shopifyCustomerPrivacy = null;
    }
}

function updateThirdPartyConsentState() {
    if (!intervals.shopifyCustomerPrivacy) {
        intervals.shopifyCustomerPrivacy = window.setInterval(updateShopifyCustomerPrivacy, 200);
    }
}

window.addEventListener('ccm19WidgetClosed', updateThirdPartyConsentState);
